module.exports = __webpack_public_path__ + "img/2.6cac92d0.svg";